import React from 'react';

export default class Draggable extends React.Component<*> {
  onDragStart = e => {
    const { onDragStart, data } = this.props;
    if (typeof onDragStart === 'function') {
      onDragStart();
    }
    try {
      e.dataTransfer.setData('text', JSON.stringify(data));
    } catch (error) {
      console.warn(error);
    }
  };
  onDragEnd = e => {
    const { onDragEnd } = this.props;
    if (typeof onDragEnd === 'function') {
      onDragEnd(e);
    }
  };

  render(): React.Element<*> {
    const { children } = this.props;
    return (
      <div
        draggable
        onDragStart={this.onDragStart}
        onDragEnd={this.onDragEnd}
        className="drag-container"
      >
        {children}
      </div>
    );
  }
}
